// extracted by mini-css-extract-plugin
var _1 = "signUp-module_body__YBUXX0";
var _2 = "signUp-module_btnContainer__D8JFkH";
var _3 = "signUp-module_captchaContainer__KpBZHU";
var _4 = "signUp-module_gray_text__hap7T7";
var _5 = "signUp-module_header__qAQ391";
var _6 = "signUp-module_icon__dzbD0C";
var _7 = "signUp-module_img__i8Z3iT";
var _8 = "signUp-module_imgContainer__JkJzE9";
var _9 = "signUp-module_invalid_login__cYzJ4x";
var _a = "signUp-module_logContainer__gEefg0";
var _b = "signUp-module_logWrapper__C78T7v";
var _c = "signUp-module_login__Wh7B5b";
var _d = "signUp-module_password__dSqI2W";
var _e = "signUp-module_password_control__bQ3rs5";
var _f = "signUp-module_policyFooter__DgLdli";
var _10 = "signUp-module_reload__UKS9og";
var _11 = "signUp-module_rememberMe__Vbxh8A";
var _12 = "signUp-module_root__KA1C9H";
var _13 = "signUp-module_someContainer__gf07Xm";
export { _1 as "body", _2 as "btnContainer", _3 as "captchaContainer", _4 as "gray_text", _5 as "header", _6 as "icon", _7 as "img", _8 as "imgContainer", _9 as "invalid_login", _a as "logContainer", _b as "logWrapper", _c as "login", _d as "password", _e as "password_control", _f as "policyFooter", _10 as "reload", _11 as "rememberMe", _12 as "root", _13 as "someContainer" }
